import React from 'react';
import { Icon, Typo } from '@ers/ui';

const NoMessages = () => (
    <div className="messages__noMessages">
        <Icon name="message" big />
        <div>
            <Typo.Headline className="messages__noMessages--content with-margin--top-4">
                Czekamy na pierwszą wiadomość!
            </Typo.Headline>
            <Typo.Body className="messages__noMessages--content with-margin--top-3">
                Tu będą zapisywać się wszystkie Twoje rozmowy z rekruterami. Wyślemy Ci wiadomość e-mail, gdy ktoś do Ciebie napisze.
            </Typo.Body>
        </div>
    </div>
);

export default NoMessages;